import { RemoteRoomlayout } from "../../../FacilityManager/Domain/Types/FloorPlan/RoomlayoutAssignment.type";
import { RemoteRoomlayoutRows } from "../../../../hooks/Remote/Services/Roomlayout/useRemoteFetchRoomlayout";

export function mapRemoteRoomlayoutRowVal(
  roomlayout: RemoteRoomlayout | RemoteRoomlayoutRows
): RemoteRoomlayout {
  if (!roomlayout.arrangement.length) return { ...roomlayout, arrangement: [] };

  const normalizedArrangement = roomlayout.arrangement.map(row => {
    if (Array.isArray(row)) return row;
    return row.row;
  });

  return {
    ...roomlayout,
    arrangement: normalizedArrangement
  };
}
